/*
 * Payments Messages
 *
 * This contains all the text for the Payments component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Payments.header',
    defaultMessage: 'Bank Accounts',
  },
  helpAccounts: {
    id: 'app.components.Payments.helpAccounts',
    defaultMessage: "You can specify one or more bank accounts, for example, one for the school and one for the parents' association.{br}For each bank account you will need a Mollie account to make the payments on.",
  },
  helpAccountForm: {
    id: 'app.components.Payments.helpAccountForm',
    defaultMessage: 'In payment requests, both the IBAN and the name of the bank account are shown.',
  },
  helpPaymentMethods: {
    id: 'app.components.Payments.helpPaymentMethods',
    defaultMessage: 'Check the payment methods you want to support for this bank account.{br}After ticking you can indicate the transaction costs.',
  },
  transactionCostHelp: {
    id: 'app.components.Payments.transactionCostHelp',
    defaultMessage: 'Transaction costs are external costs that you have to pay, for example bank costs for direct debit or costs of an online transaction at Mollie (€ 0.35).{br}You can choose to pay these costs yourself or have them paid by the addressees of the payment request.{br}In the latter case, you can specify the transaction costs per payment method here. The amount requested is increased by the transaction costs for the selected payment method.{br}If you want to take care of the transaction costs yourself, you fill in 0 eurocent at transaction costs.',
  },
  paymentModule: {
    id: 'app.common.paymentModule',
    defaultMessage: 'Payment Module',
  },
  noAccounts: {
    id: 'app.components.Payments.noAccounts',
    defaultMessage: 'No accounts registered yet',
  },
  addAccount: {
    id: 'app.components.Payments.addAccounts',
    defaultMessage: 'Add Account',
  },
  whosAllowed: {
    id: 'app.components.Payments.whosAllowed',
    defaultMessage: 'Who is allowed to create, view and manage payment requests?',
  },
  addRoles: {
    id: 'app.components.Payments.addRoles',
    defaultMessage: 'Add Roles',
  },
  selectRoles: {
    id: 'app.components.Payments.selectRoles',
    defaultMessage: 'Select Roles',
  },
  confirmRemoveRole: {
    id: 'app.components.Payments.confirmRemoveRole',
    defaultMessage: 'Remove role {displayName}?',
  },
  alwaysAllowed: {
    id: 'app.components.Payments.alwaysAllowed',
    defaultMessage: 'School administrators and administrative staff are always allowed',
  },
  iban: {
    id: 'app.components.Payments.iban',
    defaultMessage: 'IBAN',
  },
  accountName: {
    id: 'app.components.Payments.accountName',
    defaultMessage: 'Account Name',
  },
  paymentMethods: {
    id: 'app.components.Payments.paymentMethods',
    defaultMessage: 'Payment Methods',
  },
  bankTransfer: {
    id: 'app.components.Payments.bankTransfer',
    defaultMessage: 'Bank Transfer',
  },
  directDebit: {
    id: 'app.components.Payments.directDebit',
    defaultMessage: 'Direct Debit',
  },
  onlinePayment: {
    id: 'app.components.Payments.onlinePayment',
    defaultMessage: 'Online Payment',
  },
  ok: {
    id: 'app.common.ok',
    defaultMessage: 'OK',
  },
  options: {
    id: 'app.common.options',
    defaultMessage: 'Options',
  },
  currency: {
    id: 'app.components.Payments.currency',
    defaultMessage: 'Currency',
  },
  mollieStatus: {
    id: 'app.components.Payments.mollieStatus',
    defaultMessage: 'Mollie Status',
  },
  mollieNone: {
    id: 'app.components.Payments.mollieNone',
    defaultMessage: 'Mollie not connected yet',
  },
  mollieNoneInfo: {
    id: 'app.components.Payments.mollieNoneInfo',
    defaultMessage: 'Before you can create payment requests, you need to link this bank account to your Mollie account.',
  },
  mollieNeedsData: {
    id: 'app.components.Payments.mollieNeedsData',
    defaultMessage: 'Additional data required',
  },
  mollieNeedsDataNoPayments: {
    id: 'app.components.Payments.mollieNeedsDataNoPayments',
    defaultMessage: 'Before you can create payment requests, Mollie needs more information.',
  },
  mollieNeedsDataWithPayments: {
    id: 'app.components.Payments.mollieNeedsDataWithPayments',
    defaultMessage: "You're already able to create payment requests, but Mollie needs more information to pay you.",
  },
  mollieInReview: {
    id: 'app.components.Payments.mollieInReview',
    defaultMessage: 'In review',
  },
  mollieInReviewNoPayments: {
    id: 'app.components.Payments.mollieInReviewNoPayments',
    defaultMessage: "Mollie has all the information you need and is in the process of verifying your details. You can't create payment requests yet.",
  },
  mollieInReviewWithPayments: {
    id: 'app.components.Payments.mollieInReviewWithPayments',
    defaultMessage: 'You can create a payment request, but Mollie is still verifying your information so you can be paid.',
  },
  mollieConnected: {
    id: 'app.components.Payments.mollieConnected',
    defaultMessage: 'Mollie connected',
  },
  mollieActive: {
    id: 'app.components.Payments.mollieActive',
    defaultMessage: 'Active',
  },
  toMollie: {
    id: 'app.components.Payments.toMollie',
    defaultMessage: 'To Mollie',
  },
  mollieOrganizationId: {
    id: 'app.components.Payments.mollieOrganizationId',
    defaultMessage: 'Mollie Account',
  },
  mollieProfileId: {
    id: 'app.components.Payments.mollieProfileId',
    defaultMessage: 'Profile ID',
  },
  connectViaMollie: {
    id: 'app.components.Payments.connectViaMollie',
    defaultMessage: 'Connect via Mollie',
  },
  mollieStillConnected: {
    id: 'app.components.Payments.mollieStillConnected',
    defaultMessage: 'Are you still logged in in Mollie?',
  },
  checkMollieConnection: {
    id: 'app.components.Payments.checkMollieConnection',
    defaultMessage: 'If you\'re still logged in in Mollie in this browser, please verify you\'re logged in with the account you want to connect to this bank account, or log out before continuing.',
  },
});
